import {
  ALLOCATION_TYPES,
  DAY_TYPE,
  ERSETariffsTypes,
  SEASONS_TYPES,
  ciclesTypes,
  contractTypes,
  periods,
  resourceTypes,
  userRoles,
  voltageLevelTypes,
} from "utils/constants/index";
import { MONTHS } from "utils/constants/time";

const getLabelFromValue = (array, value) => array.filter((type) => type.value === value)[0]?.label;
const getValueFromLabel = (array, label) => array.filter((type) => type.label === label)[0]?.value;

export const getCiclesTypeLabelFromValue = (value) => getLabelFromValue(ciclesTypes, value);

export const getContractTypeLabelFromValue = (value) => getLabelFromValue(contractTypes, value);

export const getPeriodLabelFromValue = (value) => getLabelFromValue(periods, value);

export const getERSETypeLabelFromValue = (value) => getLabelFromValue(ERSETariffsTypes, value);

export const getResourceTypeLabelFromValue = (value) => getLabelFromValue(resourceTypes, value);

export const getAllocationTypeLabelFromValue = (value) =>
  getLabelFromValue(ALLOCATION_TYPES, value);

export const getUserRoleLabelFromValue = (value) => getLabelFromValue(userRoles, value);

export const getVoltageLevelLabelFromValue = (value) => getLabelFromValue(voltageLevelTypes, value);

export const getSeasonLabelFromValue = (value) => getLabelFromValue(SEASONS_TYPES, value);

export const getDayTypeLabelFromValue = (value) => getLabelFromValue(DAY_TYPE, value);

export const getMonthLabelFromValue = (value) => getLabelFromValue(MONTHS, value);

export default {
  getCiclesTypeLabelFromValue,
  getContractTypeLabelFromValue,
  getERSETypeLabelFromValue,
  getResourceTypeLabelFromValue,
  getAllocationTypeLabelFromValue,
  getVoltageLevelLabelFromValue,
  getValueFromLabel,
  getMonthLabelFromValue,
};
